// common values

// var div = document.createElement("div");
// div.innerHTML = document.title;
// var contentType = null;
// var contentName = (div.textContent || div.innerText || "");

var uniqueId = function(prefix) {
    return prefix+'_' + Math.random().toString(36).substr(2, 9);
};

var pixel_trackAPIConversion = function (label, eventID, fbp, fbc, timestamp, em, ph)
{
    if (typeof fbc == 'undefined') {
        fbc = null;
    }

    console.log('trackAPIConversion', label, eventID, fbp, fbc, timestamp, em, ph);
    // var requestUrl = '/api/tracking-pixel-api-conversion/ajax.php';
    var requestUrl = url__tracking_pixel;
    var params = 'event_name='+label + '&';
    params = params + 'event_id='+eventID + '&';
    params = params + 'fbp='+fbp + '&';
    params = params + 'fbc='+fbc + '&';
    params = params + 'timestamp='+timestamp + '&';
    params = params + 'host='+(window.location.protocol + "//" + window.location.host) + '&';
    params = params + 'em='+encodeURI(em).replace('+', '%2B') + '&';
    params = params + 'ph='+encodeURI(ph).replace('+', '%2B');
    // console.log(params);

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            // Typical action to be performed when the document is ready:
            // document.getElementById("demo").innerHTML = xhttp.responseText;
        }
    };
    xhttp.open("POST", requestUrl, true);
    xhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhttp.send(params);
};

var pinterest_trackAPIConversion = function (label, attributes, eventID, timestamp)
{
    // url__tracking_pinterest
    var lang = tracking__locale;

    console.log('trackAPIConversion', label, attributes, eventID);
    var requestUrl = '/api/tracking-pinterest-api-conversion/ajax.php';
    var params = 'event_name='+label + '&';
    params = params + 'event_id='+eventID + '&';
    // params = params + 'fbp='+fbp + '&';
    // params = params + 'fbc='+fbc + '&';
    params = params + 'timestamp='+timestamp + '&';
    // params = params + 'custom_data='+JSON.stringify(attributes) + '&';
    params = params + 'language='+lang + '&';
    params = params + 'host='+(window.location.protocol + "//" + window.location.host) + '&';
    // params = params + 'em='+encodeURI(em).replace('+', '%2B') + '&';
    // params = params + 'ph='+encodeURI(ph).replace('+', '%2B');
    // console.log(params);

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            // Typical action to be performed when the document is ready:
            // document.getElementById("demo").innerHTML = xhttp.responseText;
        }
    };
    xhttp.open("POST", requestUrl, true);
    xhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhttp.send(params);
};

function fbq_track(label, counter) {
    console.log('fbq_track', label);
    if (label) {
        var now = Math.floor(Date.now() / 1000);
        var eventID = uniqueId(now);
        if (typeof fbq == 'function') {
            fbq('track', label, {}, {eventID: eventID});
            pixel_trackAPIConversion(label, eventID, getCookie('_fbp'), getCookie('_fbc'), now);
        }
    }
}

function fbq_trackCustom(label) {
    console.log('fbq_trackCustom', label);
    if (label) {
        var now = Math.floor(Date.now() / 1000);
        var eventID = uniqueId(now);
        if (typeof fbq == 'function') {
            fbq('trackCustom', label, {}, {eventID: eventID});
            pixel_trackAPIConversion(label, eventID, getCookie('_fbp'), getCookie('_fbc'), now);
        }
    }
}

function pixel_trackAPIConversion__PageView(counter, em, ph) {

    console.log('pixel_trackAPIConversion__PageView', counter);
    if (typeof pixel_PageView__now == 'undefined') {
        var pixel_PageView__now = Math.floor(Date.now() / 1000);
    }
    if (typeof pixel_PageView__eventID != 'undefined' && getCookie('_fbp')) {
        pixel_trackAPIConversion('PageView', pixel_PageView__eventID, getCookie('_fbp'), getCookie('_fbc'), pixel_PageView__now, em, ph);
    } else if (counter < 20) { // 10s + 1s
        setTimeout(function () {
            pixel_trackAPIConversion__PageView(counter + 1, em, ph);
        }, 500);
    }
}

function pinterest_trackAPIConversion__PageView(counter) {

    // console.log('pinterest_trackAPIConversion__PageView', counter);
    // if (typeof pinterest_PageView__now == 'undefined') {
    //     var pinterest_PageView__now = Math.floor(Date.now() / 1000);
    // }
    // if (typeof pinterest_PageView__eventID != 'undefined' && getCookie('_fbp')) {
    //     pinterest_trackAPIConversion('page_visit', {}, pinterest_PageView__eventID, pinterest_PageView__now);
    // } else if (counter < 20) { // 10s + 1s
    //     setTimeout(function () {
    //         pinterest_trackAPIConversion__PageView(counter + 1, em, ph);
    //     }, 500);
    // }
}

// pinterest

function pinterest_track(label, labelAPIConversion, attributes, counter)
{
    if (typeof counter == 'undefined') { counter = 0; }
    if (counter > 10) {
        return;
    }

    if (typeof pintrk == 'function') {
        var now = Math.floor(Date.now() / 1000);
        var eventID = uniqueId(now);
        pinterest_trackAPIConversion(labelAPIConversion, attributes, eventID, now);
        attributes['event_id'] = eventID;
        pintrk('track', label, attributes);
    } else {
        setTimeout(function () {
            pinterest_track(label, labelAPIConversion, attributes, counter + 1)
        }, 500);
    }
}

// converters

function track_click_video(label, slug) {
    fbq_trackCustom('click_video_'+slug);
    pinterest_track('watchvideo', 'watch_video', {
        video_title: label
    });
    dataLayer.push({
        'event': 'click',
        'context_submitted': 'click_video_'+slug
    });
}

function track_view_category(label, slug) {
    fbq_trackCustom(tracking__locale+'_view_category_'+slug);
    pinterest_track('viewcategory', 'view_category', {
        line_items: [
            {
                product_category: tracking__locale+'_'+label
            }
        ]
    });
    dataLayer.push({
        event: 'view',
        context_submitted: slug
    });
}

function track_click_social(type) {
    fbq_trackCustom(tracking__locale+'_click_social_'+type);
    pinterest_track('custom', 'click_social_', {
        social_media: tracking__locale+'_'+type

    });
    dataLayer.push({
        event: 'click_social_' + type,
        context_submitted: 'click_social_' + type ,
    });
}

// init

var pixel_callback = function () {
    console.log('pixel_callback');
    pixel_trackAPIConversion__PageView(0, pixel_em, pixel_ph);

    if (document.querySelector('body').classList.contains('single-prodotto')) {

        // ViewContent

        var pixel_ViewContent__now = Math.floor(Date.now() / 1000);
        var pixel_ViewContent__eventID = uniqueId('ViewContent_');
        pixel_trackAPIConversion('ViewContent', pixel_ViewContent__eventID, getCookie('_fbp'), getCookie('_fbc'), pixel_ViewContent__now, pixel_em, pixel_ph);
        if (typeof fbq == 'function') {
            fbq('track', 'ViewContent', {
                content_ids: tracking__viewcontent__ids,
                content_name: tracking__viewcontent__title,
                content_type: tracking__viewcontent__type
            }, {eventID: pixel_ViewContent__eventID});
        }
    }
};
var pinterest_callback = function () {
    console.log('pinterest_callback');
    // pinterest_trackAPIConversion__PageView

    if (document.querySelector('body').classList.contains('single-prodotto')) {

        // ViewContent

        pinterest_track('pagevisit', 'page_visit', {
            property: tracking__viewcontent__title,
            content_ids: tracking__viewcontent__ids
        });
        // pinterest_trackAPIConversion__PageView(0);
    }
};


function track_view_item(productObj) {
    dataLayer.push({
        "event": "view_item",
        ecommerce: {
            currency: "EUR",
            value: 0.00,
            items: [
                {
                item_id: productObj.id,
                item_name: productObj.name,
                affiliation: "Kioene",
                // coupon: "SUMMER_FUN",
                discount: 0,
                index: 0,
                item_brand: "Kioene",
                item_category: productObj.cat,
                item_list_id: "index_products",
                item_list_name: "Index Products",
                price: 0.00,
                quantity: 1
                }
            ]
            }
        }
    );
}

function track_click_item(id, name, cat, item_list_id_c, item_list_name_c){
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        "event": "select_item",
        ecommerce: {
            currency: "EUR",
            value: 0.00,
            items: [
                {
                item_id: id,
                item_name: name,
                affiliation: "Kioene",
                // coupon: "SUMMER_FUN",
                discount: 0,
                index: 0,
                item_brand: "Kioene",
                item_category: cat,
                item_list_id: item_list_id_c,
                item_list_name: item_list_name_c,
                price: 0.00,
                quantity: 1
                }
            ]
        }
    });
}

var offset_base = -100;  // abbondanza
var categoriesToTrack = [];
function initTrackingViewCategory(callback) {
    var categories = document.querySelectorAll('.js-tracking-view-category');
    // console.log('initTrackingViewCategory', categories);
    for (var i = 0; i < categories.length; i++) {
        // console.log(categories[i].getAttribute('data-context'), categories[i].getAttribute('data-context-slug'), categories[i].offsetTop);
        if (categories[i].getAttribute('data-context') && categories[i].getAttribute('data-context-slug') && categories[i].offsetTop) {
            categoriesToTrack.push({
                'offset': categories[i].offsetTop + offset_base,
                'label': categories[i].getAttribute('data-context'),
                'slug': categories[i].getAttribute('data-context-slug'),
                'tracked': false
            });
        }
    }
    if (typeof callback == 'function') {
        callback();
    }
}
function changeTrackingViewCategory() {
    for (var i = 0; i < categoriesToTrack.length; i++) {

        if (!categoriesToTrack[i].tracked) {
            var category = document.querySelector('.js-tracking-view-category[data-context-slug="'+categoriesToTrack[i].slug+'"]');
            if (category) {
                categoriesToTrack[i].offset = category.offsetTop + offset_base;
            }
        }
    }
}

function checkViewedCategory() {
    var offset = window.scrollY;
    for(var i = 0; i < categoriesToTrack.length; i++) {
        if (!categoriesToTrack[i].tracked && offset >= categoriesToTrack[i].offset) {
            categoriesToTrack[i].tracked = true;
            track_view_category(categoriesToTrack[i].label, categoriesToTrack[i].slug);
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {

    // video

    if (document.querySelectorAll('.js-tracking-click-video').length) {
        var elements = document.querySelectorAll('.js-tracking-click-video');
        for (var i = 0; i < elements.length; i++) {
            elements[i].addEventListener('click', function (event) {
                event.preventDefault();
                track_click_video(event.target.getAttribute('data-context'), event.target.getAttribute('data-context-slug'));
            }, false);
        }
    }

    // category

    if (document.querySelectorAll('.js-tracking-view-category').length) {

        initTrackingViewCategory(function () {
            if (document.querySelector('body').classList.contains('tax-linea')) {
                categoriesToTrack[0].tracked = true;
                track_view_category(categoriesToTrack[0].label, categoriesToTrack[0].slug);
            }
        });
        window.addEventListener('resize', function() {
            changeTrackingViewCategory();
        });

        // if (document.querySelector('.show-prodotti')) {
        //     document.querySelector('.show-prodotti').addEventListener('click', function (event) {
        //         setTimeout(changeTrackingViewCategory, 1000);
        //         dataLayer.push({
        //             'event': 'click',
        //             'context_submitted': 'click_show_all_'+event.target.getAttribute('data-context-slug')
        //         });
        //     });
        // }

        document.addEventListener('scroll', function (event) {
            checkViewedCategory();
        });
    }

    if (document.querySelectorAll('.js-tracking-social-media').length) {
        var elements = document.querySelectorAll('.js-tracking-click-social-media');
        for (var i = 0; i < elements.length; i++) {
            elements[i].addEventListener('click', function (event) {
                // event.preventDefault();
                track_click_social(event.target.closest(".js-tracking-click-social-media").getAttribute('data-context'));
            }, false);
            
        }
    }

    if (document.querySelector('body').classList.contains('single-prodotto')) {
        console.log(productTrackingObj);
        pixel_callback();
        pinterest_callback();
        track_view_item(productTrackingObj);
    }


    // contact

    // var wpcf7Elm = document.querySelector( '.wpcf7' );
    //
    // if (wpcf7Elm) {
    //     wpcf7Elm.addEventListener( 'wpcf7submit', function( event ) {
    //         fbq_track('Contact')
    //         dataLayer.push({
    //             'event': 'submit',
    //             'context_submitted': 'contact'
    //         });
    //     }, false );
    // }
});